import {CardType, TaskType} from 'constants/dataEnum';
import PropTypes from 'prop-types';
import {mergeRefs} from 'lib/refHelper';
import React, {useRef} from 'react';
import {useArrowDownPress, useArrowUpPress} from 'lib/customHooks';
import PoolingTaskTransfer from './Tasks/PoolingTaskTransfer';
import PoolingAspirateVolume from './Tasks/PoolingAspirateVolume';

const PoolingTasksContainer = React.forwardRef(
  (
    {
      card,
      disallowEdit,
      executionStatus,
      isHighlighted,
      labware,
      labwareState,
      reuseTips,
      runtimeMode,
      showEditButton,
      tasks,
      onArrowUpPress,
      onArrowDownPress,
      onEdit,
      onSelectTask,
      onReuseTipsChange,
      readOnly,
    },
    ref,
  ) => {
    const taskRef = useRef(null);
    const aspirateTasks = tasks.filter((task) => task.type === TaskType.ASPIRATE);
    const dispenseTasks = tasks.filter((task) => task.type === TaskType.DISPENSE);

    const aspirateVolume = aspirateTasks?.length > 0 && aspirateTasks[0].volume;

    useArrowUpPress(taskRef, onArrowUpPress);
    useArrowDownPress(taskRef, onArrowDownPress);

    return (
      <div className="wrapper" ref={mergeRefs(taskRef, ref)} role="presentation">
        {aspirateTasks?.length > 0 && labware && (
          <div
            onClick={(e) => {
              onSelectTask(1, CardType.POOLING, tasks, card.ID);
              e.stopPropagation();
            }}
          >
            <PoolingTaskTransfer
              key={`task-pooling-1-${card.ID}`}
              disallowEdit={() => disallowEdit(1)}
              executionStatus={executionStatus(1)}
              tasks={aspirateTasks}
              number={1}
              labware={labware}
              labwareState={labwareState}
              runtimeMode={runtimeMode}
              isHighlighted={
                isHighlighted?.type === CardType.POOLING && isHighlighted?.cardID === card.ID && isHighlighted?.ID === 1
              }
              onEdit={() => onEdit(1)}
              showEditButton={showEditButton}
              readOnly={readOnly}
            />
          </div>
        )}
        {aspirateVolume && labware ? (
          <div
            onClick={(e) => {
              onSelectTask(2, CardType.POOLING, tasks, card.ID);
              e.stopPropagation();
            }}
          >
            <PoolingAspirateVolume
              key={`task-pooling-2-${card.ID}`}
              disallowEdit={() => disallowEdit(2)}
              executionStatus={executionStatus(2)}
              tasks={aspirateTasks}
              number={2}
              labware={labware}
              labwareState={labwareState}
              onEdit={() => onEdit(2)}
              reuseTips={reuseTips}
              onReuseTipsChange={onReuseTipsChange}
              runtimeMode={runtimeMode}
              isHighlighted={
                isHighlighted?.type === CardType.POOLING && isHighlighted?.cardID === card.ID && isHighlighted?.ID === 2
              }
              showEditButton={showEditButton}
              readOnly={readOnly}
            />
          </div>
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <></>
        )}
        {dispenseTasks?.length > 0 && labware && (
          <div
            onClick={(e) => {
              onSelectTask(3, CardType.POOLING, tasks, card.ID);
              e.stopPropagation();
            }}
          >
            <PoolingTaskTransfer
              key={`task-pooling-3-${card.ID}`}
              disallowEdit={() => disallowEdit(3)}
              executionStatus={executionStatus(3)}
              tasks={dispenseTasks}
              number={3}
              labware={labware}
              labwareState={labwareState}
              runtimeMode={runtimeMode}
              isHighlighted={
                isHighlighted?.type === CardType.POOLING && isHighlighted?.cardID === card.ID && isHighlighted?.ID === 3
              }
              onEdit={() => onEdit(3)}
              showEditButton={showEditButton}
              readOnly={readOnly}
            />
          </div>
        )}
      </div>
    );
  },
);

PoolingTasksContainer.propTypes = {
  card: PropTypes.object.isRequired,
  disallowEdit: PropTypes.func,
  executionStatus: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool,
  labware: PropTypes.object.isRequired,
  labwareState: PropTypes.object.isRequired,
  reuseTips: PropTypes.bool,
  runtimeMode: PropTypes.bool.isRequired,
  showEditButton: PropTypes.bool,
  tasks: PropTypes.array.isRequired,
  onArrowUpPress: PropTypes.func,
  onArrowDownPress: PropTypes.func,
  onEdit: PropTypes.func,
  onReuseTipsChange: PropTypes.func,
  onSelectTask: PropTypes.func,
  readOnly: PropTypes.bool.isRequired,
};

PoolingTasksContainer.defaultProps = {
  disallowEdit: () => {},
  isHighlighted: false,
  reuseTips: true,
  showEditButton: false,
  onArrowUpPress: () => {},
  onArrowDownPress: () => {},
  onEdit: () => {},
  onReuseTipsChange: () => {},
  onSelectTask: () => {},
};

export default PoolingTasksContainer;
